/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Save_New_LabelInputs */



/**
* | output |
* | --- |
* | "Save new metadata" |
*
* @param {Event_Group_Metadata_Save_New_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_save_new_label = /** @type {((inputs?: Event_Group_Metadata_Save_New_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Save_New_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer de nouvelles métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Metadaten speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva nuovi metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить новые метаданные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar nuevos metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存新元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいメタデータを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया मेटाडेटा सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar novos metadados")
	return /** @type {LocalizedString} */ ("Save new metadata")
});